import React, { useState } from "react";
import { InputNumber, InputNumberProps } from "antd";

interface FloatInputProps extends InputNumberProps {
    label: string,
}

const FloatInputNumber = (props: FloatInputProps) => {
    const [focus, setFocus] = useState(false);
    let { label, placeholder, required, ...rest } = props;

    if (!placeholder) placeholder = label;

    //   const isOccupied = focus || (value && value.length !== 0);
    const isOccupied = focus || (rest.value || rest.value === 0);

    const labelClass = isOccupied && label ? "label as-label" : "label as-placeholder";

    const requiredMark = required ? <span className="text-danger">*</span> : null;

    return (
        <div
            className="custom-input"
            onBlur={() => setFocus(false)}
            onFocus={() => setFocus(true)}
        >

            <InputNumber
                controls={false}
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                parser={value => (value?.replace(/\$\s?|(\.*)/g, '') || "0")}
                {...rest}
            />
            <label className={labelClass}>
                {isOccupied ? label : placeholder} {requiredMark}
            </label>
        </div>
    );
};

export default FloatInputNumber;
